<template>
  <div>
    <el-dialog
      :visible="visible"
      title="忘记密码"
      width="600px"
      :close-on-click-modal="false"
      @close="closeModal"
    >
      <div class="text item changepass_content">
        <!-- <div v-if="step === 1">
          <el-form status-icon label-width="100px" class="demo-ruleForm">
            
          </el-form>
        </div> -->
        <div v-if="step === 1">
          <el-form status-icon label-width="100px" class="demo-ruleForm">
            <el-form-item label="手机号码">
              <el-input
                size="small"
                v-model="phoneNum"
                placeholder="请输入手机号码"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="验证码">
              <el-input
                size="small"
                v-model="verificationCode"
                placeholder="请输入验证码"
                clearable
              ></el-input>
              <el-button size="mini" :disabled="countdown > 0" @click="getVerificationCode">
                {{ countdown === 0 ? '获取验证码' : `${countdown}S` }}
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="step === 2">
          <el-form
            :model="ruleForm"
            status-icon
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="更改密码" prop="pass">
              <el-input
                size="small"
                type="password"
                v-model="ruleForm.newPassword"
                placeholder="请输入新密码"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPass">
              <el-input
                size="small"
                type="password"
                v-model="ruleForm.checkPass"
                placeholder="请再次输入新密码"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- <span v-if="step === 1" slot="footer" class="dialog-footer">
        <el-button size="mini" @click="toStep(2)">下一步</el-button>
      </span> -->
      <span v-if="step === 1" slot="footer" class="dialog-footer">
        <el-button size="mini" @click="toStep(2)">下一步</el-button>
      </span>
      <span v-if="step === 2" slot="footer" class="dialog-footer">
        <el-button size="mini" @click="toStep(1)">上一步</el-button>
        <el-button :loading="btnLoading" type="primary" size="mini" @click="submitFrom">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { encodeKey } from '@/utils'
import request from '@/utils/request'
import { Storage } from '@/utils/storage'
export default {
  props: {
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        newPassword: '',
        checkPass: ''
      },
      rules: {
        newPassword: [{ validator: validatePass, trigger: 'blur' }],
        checkPass: [{ validator: validatePass2, trigger: 'blur' }]
      },
      btnLoading: false,
      step: 1,
      countdown: 0,
      timer: null,
      verificationCode: '',
      phoneNum:'',
      token: ''
    }
  },
  methods: {
    submitFrom() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          const submitFormData = {}
          submitFormData['pazjofxkyvyoosot'] = encodeKey(this.ruleForm.newPassword)
          request
            .post('/mdm/mdmUserController/resetMyselfPassword', {
              ...submitFormData
            })
            .then((res) => {
              this.btnLoading = false
              if (res.success) {
                this.$emit('closeModal')
                this.$message.success('修改成功')
                Storage.l.remove('TokenKey')
                this.closeModal()
              }
            })
            .catch((e) => {
              this.btnLoading = false
            })
        } else {
          return false
        }
      })
    },
    //跳转到对应的步骤
    toStep(num) {
      if (num === 2) {
        request
          .post('/mdm/mdmDmsMallLoginController/loginAndResetByPhoneVerification',{
            vfymxygsefoeapvk: this.verificationCode,
            twpbmjhfxodboggf: this.phoneNum
          })
          .then((res) => {
            if (res.success) {
              this.step = num
              Storage.l.set('TokenKey',res.result.loginUserToken)
            }
          })
      }else {
        this.step = num
      }
    },
    //关闭弹窗
    closeModal() {
      clearInterval(this.timer)
      this.$emit('onClose')
    },
    //获取验证码
    getVerificationCode() {
      request
        .post('/mdm/mdmDmsMallLoginController/sendVerificationForLoginAndResetByMessage',{
          twpbmjhfxodboggf: this.phoneNum
        })
        .then((res) => {
          if (res.success) {
            this.$message.success('消息发送成功')
            this.countdown = 60
            this.timer = setInterval(() => {
              if (this.countdown > 0) {
                this.countdown--
              } else {
                clearInterval(this.timer)
              }
            }, 1000)
          }
        })
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style scoped lang="scss"></style>
